module.exports = __webpack_public_path__ + "Teams.de87e16ddabd3f69dcc35a031d35a9b0.hashedasset.svg";